import BaseStore from '@/store/base-store'

export default new BaseStore('machineries')



// WEBPACK FOOTER //
// ./src/store/modules/customer-machineries.store.js